import { yupResolver } from '@hookform/resolvers/yup';
import LogoImg from 'assets/images/logo_login.png';
import WaveBackground from 'assets/images/wave_background.png';
import { notify } from 'components/ToastNotification/ToastNotification';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import paths from 'shared/paths';
import { useResetPasswordFinishLazyQuery } from 'src/graphql/generated';
import { ToastTypes } from 'types/CommonTypes';
import {
    FormWrapper,
    Logo,
    PageBox,
    PageWrapper,
    StyledButton,
    StyledInput,
    StyledLink,
    WaveWrapper,
} from '../SharedLogin.styled';
import { validationNewPassword } from '../validations';

interface NewPasswordFormInputs {
    email: string;
    password: string;
    code: string;
}

export const NewPassword = () => {
    const history = useHistory();

    const {
        control,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
    } = useForm<NewPasswordFormInputs>({
        resolver: yupResolver(validationNewPassword),
    });

    const [resetPasswordFinish, { loading }] =
        useResetPasswordFinishLazyQuery();

    const onSubmit = async (data: NewPasswordFormInputs) => {
        try {
            const response = await resetPasswordFinish({
                variables: {
                    email: data.email,
                    password: data.password,
                    code: data.code,
                },
            });

            if (response.data?.resetPasswordFinish) {
                history.push(paths.login);
                notify('Hasło zostało zresetowane pomyślnie')[
                    ToastTypes.SUCCESS
                ]();
                reset();
            } else {
                console.error('Reset password error:', response);
                response?.error?.message === 'Invalid code'
                    ? notify('Nie udało się zresetować hasła, błędny kod')[
                          ToastTypes.ERROR
                      ]()
                    : notify(
                          'Nie udało się zresetować hasła, spróbuj ponownie: ' +
                              response.error?.message,
                      )[ToastTypes.ERROR]();
            }
        } catch (error) {
            console.error('Reset password error:', error);
            notify('Nie udało się zresetować hasła, spróbuj ponownie')[
                ToastTypes.ERROR
            ]();
        }
    };

    return (
        <PageWrapper>
            <StyledLink to={paths.login}>
                <Logo src={LogoImg} />
            </StyledLink>
            <WaveWrapper src={WaveBackground} />
            <PageBox>
                <FormWrapper onSubmit={handleSubmit(onSubmit)}>
                    <StyledInput
                        control={control}
                        errors={errors.email}
                        name={'email'}
                        placeholder={'Email'}
                        type={'text'}
                        marginBottom={20}
                        iconType={'Email'}
                    />
                    <StyledInput
                        control={control}
                        errors={errors.code}
                        iconType={'Password'}
                        marginBottom={20}
                        maxLength={6}
                        name={'code'}
                        placeholder={'Kod resetowania'}
                        type={'number'}
                    />
                    <StyledInput
                        control={control}
                        errors={errors.password}
                        name={'password'}
                        placeholder={'Nowe hasło'}
                        type={'password'}
                        marginBottom={30}
                        iconType={'Password'}
                    />
                    <StyledButton
                        buttonType={'black'}
                        type="submit"
                        disabled={isSubmitting || loading}
                    >
                        {isSubmitting || loading
                            ? 'Resetowanie hasła...'
                            : 'Zresetuj hasło'}
                    </StyledButton>
                </FormWrapper>
            </PageBox>
        </PageWrapper>
    );
};
